import React from "react";

interface MetricItem {
  label: string;
  value: number | null;
  unit: string;
}

interface DayMetricsCardProps {
  title: string;
  theme: "blue" | "orange";
  metrics: MetricItem[];
}

const DayMetricsCard: React.FC<DayMetricsCardProps> = ({ title, theme, metrics }) => {
  const accentGradient =
    theme === "blue"
      ? "from-sky-400 to-blue-500"
      : "from-amber-400 to-orange-500";
  const dotColor = theme === "blue" ? "bg-blue-500" : "bg-orange-500";

  return (
    <div className="bg-white p-2.5 px-3 rounded-xl border border-slate-100 shadow-sm flex flex-col gap-2 relative overflow-hidden transition-all duration-300 hover:shadow-md">
      <div className={`absolute left-0 top-0 bottom-0 w-[4px] bg-gradient-to-b ${accentGradient}`} />

      <div className="flex items-center justify-between pl-1">
        <span className="text-xs font-medium text-slate-700 tracking-wide flex items-center gap-1.5">
          <span className={`w-2 h-2 rounded-full ${dotColor} animate-pulse`} />
          {title}
        </span>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {metrics.map((m) => (
          <div
            key={m.label}
            className="bg-slate-50/60 p-2 rounded-lg border border-slate-100 flex flex-col gap-0.5"
          >
            <span className="text-[9px] uppercase font-medium tracking-wider text-slate-400">
              {m.label}
            </span>
            <div className="flex items-baseline gap-1">
              <span className="text-sm font-medium text-slate-700">
                {m.value !== null ? m.value.toFixed(2) : "--"}
              </span>
              {m.value !== null && (
                <span className="text-[9px] font-normal text-slate-400">
                  {m.unit}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DayMetricsCard;
